"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomFieldValidator = void 0;
/**
 * @enum
 * @description The keys that can be added for Custom field validation.
 * @note They have to follow the rules mentioned in the below link. Any further enums that we add have to be supported in the custom form component as well
 * @link https://rjsf-team.github.io/react-jsonschema-form/docs/usage/validation/#api-documentation
 */
var CustomFieldValidator;
(function (CustomFieldValidator) {
    CustomFieldValidator["MINIMUM"] = "minimum";
    CustomFieldValidator["MAX_LENGTH"] = "maxLength";
})(CustomFieldValidator = exports.CustomFieldValidator || (exports.CustomFieldValidator = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmllbGQtdmFsaWRhdG9ycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jdXN0b20tZmllbGQtY29uZmlnL3R5cGVzL2ZpZWxkLXZhbGlkYXRvcnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7R0FNRzs7O0FBRUg7Ozs7O0dBS0c7QUFDSCxJQUFZLG9CQUdYO0FBSEQsV0FBWSxvQkFBb0I7SUFDOUIsMkNBQW1CLENBQUE7SUFDbkIsZ0RBQXdCLENBQUE7QUFDMUIsQ0FBQyxFQUhXLG9CQUFvQixHQUFwQiw0QkFBb0IsS0FBcEIsNEJBQW9CLFFBRy9CIn0=